import { defineMessage } from 'services/localization';

export const messages = {
    sameAsBillingAddress: defineMessage('same_as_billing_address_1'),
    country: defineMessage('country'),
    cityTown: defineMessage('citytown_1'),
    stateRegion: defineMessage('stateregion'),
    address: defineMessage('address'),
    attention: defineMessage('attention'),
};
